export const CONSENT_STORAGE_KEY = "cookieConsent";

export type ConsentSettings = {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
};

export type GoogleConsentState = "granted" | "denied";

export type GoogleConsentUpdate = {
  analytics_storage: GoogleConsentState;
  ad_storage: GoogleConsentState;
  ad_user_data: GoogleConsentState;
  ad_personalization: GoogleConsentState;
};

export const DEFAULT_CONSENT: ConsentSettings = {
  necessary: true,
  analytics: false,
  marketing: false,
};

export const DENIED_OPTIONAL_CONSENT: ConsentSettings = {
  necessary: true,
  analytics: false,
  marketing: false,
};

export const ACCEPTED_ALL_CONSENT: ConsentSettings = {
  necessary: true,
  analytics: true,
  marketing: true,
};

export function readConsentSettings(): ConsentSettings | null {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<ConsentSettings>;
    if (typeof parsed !== "object" || parsed === null) return null;

    return {
      necessary: true,
      analytics: Boolean(parsed.analytics),
      marketing: Boolean(parsed.marketing),
    };
  } catch {
    return null;
  }
}

export function writeConsentSettings(next: ConsentSettings): void {
  localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent("consent:updated", { detail: next }));
}

export function hasMarketingConsent(): boolean {
  const s = readConsentSettings();
  return Boolean(s?.marketing);
}

export function hasAnalyticsConsent(): boolean {
  const s = readConsentSettings();
  return Boolean(s?.analytics);
}

/** Map UI cookie preferences to Google Consent Mode v2 signals. */
export function toGoogleConsentUpdate(settings: ConsentSettings | null | undefined): GoogleConsentUpdate {
  const analytics = settings?.analytics ? "granted" : "denied";
  const ads = settings?.marketing ? "granted" : "denied";

  return {
    analytics_storage: analytics,
    ad_storage: ads,
    ad_user_data: ads,
    ad_personalization: ads,
  };
}
